import "./Certification.css";

const Certification = () => {
  return (
    <>
      <section className="Privacy_Policy Certification">
        <div className="bg_img_div">
          <div className="white_bg_div">
            <div className="container-fluid">
              <p className="section_title heading_text">
                Lab Diamond Certifications
              </p>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="main_content_div theme_bg_primary_colour">
            <p className="point_text">What is Diamond Certification? </p>
            <p className="dark_black_text">
              A diamond certification, more commonly referred to as a diamond
              grading report or quality document, is an in-depth assessment of a
              diamond's many aspects. It consists of its size, clarity, hue,
              polish, symmetry and other factors that affect its value. The
              process involves an expert gemologist analysing it through close
              inspection with the use of a jeweller’s loupe, microscope and
              likewise tools. A comprehensive certificate is then prepared by
              these qualified professionals who provide a precise and impartial
              judgement of the stone.
            </p>

            <p className="point_text">Why is certification important? </p>
            <p className="dark_black_text">
              An independent and reputable certification laboratory is essential
              if you want an unbiased assessment of a diamond's quality. By
              doing so, consumers can easily compare lab-grown diamonds on their
              specific parameters to know they're getting what they're paying
              for. The diamond industry widely accepts IGI's diamond grading
              reports for their accuracy, reliability, and impartiality.
            </p>

            <p className="point_text">More about IGI </p>
            <p className="dark_black_text">
              IGI (International Gemological Institute) is the leading grading
              body in the diamond industry that provides specific gradings for
              the four Cs in lab-created diamonds. As the most popular
              lab-created diamond certifier, IGI is used by the majority of the
              lab market, ensuring consistency in grading.
            </p>

            <div className="edu_img_holder certificate_img">
              <img
                src="/assets/images/certificate/img1.webp"
                className="edu_img"
              />
            </div>

            <p className="point_text">Certification Information </p>
            <p className="normal_text">
              Diamond certification reports usually include the following
              information:
              <br />
              Carat weight <br />
              Cut grade (for round diamonds) <br />
              Colour grade <br />
              Clarity grade <br />
              Polish grade <br />
              Symmetry grade <br />
              Proportions (crown height, pavilion depth, etc.) <br />
              Fluorescence Comments or remarks <br />
              The report may also include a diagram or plot of the diamond's
              inclusions, which are used as unique identifiers.
              <br />
              IGI laser inscribes the report number into the girdle of the
              diamond. This is easily verified with a magnification loop.
            </p>

            <div className="edu_img_holder certificate_img">
              <img
                src="/assets/images/certificate/img2.jpg"
                className="edu_img"
              />
            </div>

            <p className="point_text">ARC offers Certified Solitaires </p>
            <p className="dark_black_text">
              ARC DIAMOND JEWELRY RECOMMENDS going with IGI Certified Diamond
              Solitaires to ensure authenticity and value. We provide IGI
              certification for diamonds above 1 ct.
            </p>

            <p className="point_text">Make an informed choice </p>
            <p className="dark_black_text">
              All in all, certification is an integral part of your comfort
              about the verification of the diamond you are choosing to wear.
              IGI certifications is the most trusted third-party diamond
              graders. Researchers have pointed out that these labs apply
              stricter standards and demonstrate more consistency than other
              grading organisations. Hence, relying on this certification gives
              one the certainty they need when considering a diamond purchase.{" "}
            </p>
          </div>
        </div>
      </section>
      {/* <Stay_Connected /> */}
    </>
  );
};

export default Certification;
